import React, { FC } from 'react'
import { PLANN3R_COLOR } from '../../../../constants'

import { IProps } from './types'

const TextField: FC<IProps> = ({
  id, label, required, placeholder, value, colors, onChange,
}) => {
  return (
    <div key={id} className="page_field">
      <label
        style={{
          color: colors?.primary ?? PLANN3R_COLOR,
        }}
      >
        {label}
        {required && <sup>*</sup>}
      </label>
      <div className="field">
        <input
          className="input"
          type="text"
          value={value}
          placeholder={placeholder}
          id={id.toString()}
          onChange={(e) => { if (onChange) onChange(e.target.value) }}
        />
      </div>
    </div>
  )
}

export default TextField
